import { render, staticRenderFns } from "./lossWeightFollow.vue?vue&type=template&id=016dfb7b&scoped=true&"
import script from "./lossWeightFollow.vue?vue&type=script&lang=js&"
export * from "./lossWeightFollow.vue?vue&type=script&lang=js&"
import style0 from "./lossWeightFollow.vue?vue&type=style&index=0&id=016dfb7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016dfb7b",
  null
  
)

export default component.exports